import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../UI/Typography'
import Button from '../UI/Button'
import { device } from '../../utils/helpers'
import Question from '../UI/Question'
import { Link } from 'react-router-dom'
import { Link as ScrollLink, Element, Events, scrollSpy } from 'react-scroll'

const faqItems = [
  {
    name: 'Configuratore',
    questions: [
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Come funziona il CONFIGURATORE?
        </Typography>,
        answer: <Fragment>
          <Typography minSize='16px' maxSize='24px'>
            Il CONFIGURATORE permette di creare la soluzione di noleggio più adatta alle tue esigenze. Seguendo i vari step si può scegliere tra differenti pacchetti (BASE, TOP e PRO) per la creazione del campo sportivo che desideri noleggiare. Procedendo nella configurazione potrai aggiungere le componenti più adatte alle tue necessità (ad es. aggiungere transenne, reti di protezione, etc) e selezionare la personalizzazione delle stesse (ad esempio brandizzazione con PVC o con TNT per quanto riguarda le <i>transenne</i>)
          </Typography>
          <Typography minSize='16px' maxSize='24px'>
            Possono essere inseriti anche componenti aggiuntivi identificati nel configuratore come EXTRA quali casse audio, impianto di illuminazione, gazebi etc. Ancora dubbi? guarda il <Link to='/come-funziona'>tutorial</Link>!
          </Typography>
        </Fragment>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Cosa devo fare dopo aver concluso il preventivo?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          Nulla! Al termine della configurazione ti verrà richiesto di inserire i dati dove essere ricontattato. Riceverai una mail di riepilogo e non dovrai fare altro che attendere la telefonata di un nostro consulente! Il servizio di configurazione e preventivazione è totalmente GRATUITO!
        </Typography>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Posso interrompere la configurazione e riprenderla in un secondo momento?
        </Typography>,
        answer: <Fragment>
          <Typography minSize='16px' maxSize='24px'>
            La singola sessione ha durata di 30 minuti. Entro questo arco di tempo è possibile interrompere la configurazione e riprenderla in un secondo momento.
          </Typography>
          <Typography minSize='16px' maxSize='24px'>
            Trascorsi 30 minuti la configurazione dovrà essere ripresa dall’inizio.
          </Typography>
        </Fragment>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Che differenza c’è tra i vari pacchetti?
        </Typography>,
        answer: <Fragment>
          <Typography minSize='16px' maxSize='24px'>
            È possibile scegliere tra 3 differenti pacchetti: BASE, PRO e TOP.
          </Typography>
          <Typography minSize='16px' maxSize='24px'>
            Ogni pacchetto presenta una preselezione di determinati componenti che permettono la configurazione della struttura. Il pacchetto BASE propone la configurazione più semplice (ad es. solo il campo da gioco per quanto riguarda il calcetto); il pacchetto PRO propone una configurazione intermedia ( ad es campo + transenne di protezione) mentre il TOP propone una configurazione completa (ad es. campo + transenne di protezione laterale + americana con rete di protezione).
          </Typography>
        </Fragment>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Devo registrarmi per effettuare un preventivo?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          Non è richiesta alcuna registrazione per ricevere il preventivo. È sufficiente inserire i propri recapiti per essere ricontattati da un nostro consulente specializzato.
        </Typography>
      }
    ]
  },
  {
    name: 'Preventivo',
    questions: [
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Il servizio è a pagamento?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          Il servizio è totalmente gratuito e non è richiesto alcun tipo di registrazione!
        </Typography>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Il preventivo è vincolante?
        </Typography>,
        answer: <Fragment>
          <Typography minSize='16px' maxSize='24px'>
            Quanto emesso dal CONFIGURATORE <u>non rappresenta in alcun modo una proposta vincolante</u> né per l’UTENTE né per Noleggiocampi.it.
          </Typography>
          <Typography minSize='16px' maxSize='24px'>
            Il documento serve ad avere una quotazione di massima che dovrà poi essere vagliata dall’ufficio tecnico che, dopo aver verificato tutte le condizioni di fattibilità del noleggio, contatterà il cliente ed in seguito confermerà il noleggio con l’emissione di un preventivo ufficiale.
          </Typography>
        </Fragment>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Posso cambiare la mia configurazione?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          Una volta inviata la propria configurazione non sarà possibile modificare la selezione. Ma non preoccuparti, trattandosi di un preventivo non vincolante potrai chiedere di cambiare la tua configurazione di noleggio in qualsiasi momento scrivendo a <a href='mailto:info@noleggiocampi.it'>info@noleggiocampi.it</a> oppure chiamando il (+39) 02 36518242.
        </Typography>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Dove trovo il mio preventivo?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          Riceverai un resoconto della tua configurazione via e-mail. Controlla anche la casella SPAM!
        </Typography>
      }
    ]
  },
  {
    name: 'Destinazioni',
    questions: [
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Non riesco ad inserire la mia destinazione. Posso ugualmente richiedere un preventivo?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          Se l’indirizzo dove richiedere il noleggio non è disponibile significa che sei in una zona difficile da raggiungere. Puoi comunque inviare la tua richiesta passando allo step successivo. In questo caso le spese di trasporto e montaggio non verranno calcolate e valuteremo con un preventivo ad hoc la fattibilità del noleggio. Ricordati di specificare l’indirizzo nelle note al termine della configurazione!
        </Typography>
      },
      {
        question: <Typography minSize='16px' maxSize='24px'>
          Quali sono le località coperte dal noleggio?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          Per visionare l’elenco completo delle località coperte vedi la <Link to='/dove-noleggiamo'>tabella</Link>.
        </Typography>
      }
    ]
  },
  {
    name: 'Prezzi',
    questions: [
      {
        question: <Typography minSize='16px' maxSize='24px'>
          I prezzi esposti comprendono IVA?
        </Typography>,
        answer: <Typography minSize='16px' maxSize='24px'>
          I prezzi sono esposti in € (euro) comprensivi di IVA (22%). Nella side-bar, in basso a destra nel CONFIGURATORE, viene sempre evidenziato lo scorporo IVA. Inoltre nella pagina di riepilogo finale (e nella mail di ricezione ordine/configurazione) vengono indicati tutti prezzi al netto e separatamente il valore dell’IVA.
        </Typography>
      }
    ]
  }
]

// Features
const Wrapper = styled.div`
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 120px;
  }
`

const Section = styled.section`
  background: ${props => props.grey ? props.theme.color.bgLight : '#fff'};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const InfoSection = styled.section`
  width: 100%;
  text-align: left;
  background: #f3f3f3;
  padding: 4rem 0;
  display: flex;
  justify-content: center;

  @media ${device.laptop} {
    padding: 7rem 0;
  }
`

const Content = styled.div`
  display: flex;
  width: 95%;
  flex-direction: column;

  @media ${device.tablet} {
    padding: 7rem 0;
    justify-content: space-between;
    flex-direction: row;
  }

  @media ${device.laptop} {
    width: 70%;
  }
`

const Title = styled.div`
  padding: 3.6rem 1.5rem;
  text-align: center;
`

const BigTitle = styled.div`
  padding: 4.5rem 4.5rem 0 4.5rem;
  text-align: center;

  @media ${device.laptop} {
    width: 500px;
  }

  @media ${device.laptopL} {
    width: 700px;
  }
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-bottom: 30px;
  width: 90%;

  @media ${device.tablet} {
    width: 65%;
    padding-bottom: 40px;
  }

  @media ${device.desktop} {
    width: 65%;
    padding-bottom: 40px;
  }
`

const ButtonWrapper = styled.div`
  padding: 4.5rem 0;

  @media ${device.tablet} {
    padding: 2.5rem 1.5rem;
  }

  @media ${device.laptop} {
    padding-bottom: 4rem;
  }
`

const Topic = styled.div`
  border-bottom: 1px solid #999999;
  padding: 20px 0;
`

const SideMenu = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-bottom: 30px;

  @media ${device.tablet} {
    text-align: left;
  }
`

const Item = styled.div`
  padding-bottom: 20px;
  cursor: pointer;
  ${'' /* ${Typography} {
    &:hover {
      color: #fca317;
    }
  } */}
`

class FAQ extends Component {
  componentDidMount () {
    Events.scrollEvent.register('begin', function () {
      console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      console.log('end', arguments)
    })

    scrollSpy.update()
  }

  render () {
    return (
      <Wrapper>
        <Helmet>
          <title>Domande Frequenti Noleggiocampi.it</title>
          <meta name='Description' content='Pagina di supporto agli utenti dove è possibile trovare risposta alle principali problematiche derivanti dall utilizzo del CONFIGURATORE di Noleggiocampi.it' />
          <meta name='Keywords' content='campi smontabili,noleggio attrezzature sportive,noleggio impianti sportivi mobili' />
          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        <Title>
          <Typography padding='0 0 20px 0' variant='h1' type='title'>FAQ</Typography>
          <Typography variant='h2' type='title'>
            DOMANDE FREQUENTI
          </Typography>
        </Title>
        <InfoSection>
          <Content>
            <SideMenu>
              {faqItems.map((topic, index) => {
                return (
                  <Item key={index}>
                    <ScrollLink activeClass='active' to={topic.name} spy smooth offset={-150} duration={500}>
                      <Typography variant='h5' type='title'>{topic.name}</Typography>
                    </ScrollLink>
                  </Item>
                )
              })}
            </SideMenu>
            <Info>
              {faqItems.map((topic, index) => {
                return (
                  <Fragment key={index}>
                    <Element name={topic.name} className='element'>
                      <Topic style={{ paddingTop: index < 1 && '0' }}>
                        <Typography variant='h5' type='title'>{topic.name}</Typography>
                      </Topic>
                      {topic.questions.map((item, index) => {
                        return (
                          <Question question={item.question} answer={item.answer} key={index} />
                        )
                      })}
                    </Element>
                  </Fragment>
                )
              })}
            </Info>
          </Content>
        </InfoSection>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              HAI ALTRE DOMANDE?
            </Typography>
          </BigTitle>
          <ButtonWrapper>
            <Button secondary to='/contattaci'>CONTATTACI</Button>
          </ButtonWrapper>
        </Section>
      </Wrapper>
    )
  }
}

export default FAQ



// WEBPACK FOOTER //
// ./src/components/Pages/Faq.js